/* eslint-disable no-console */
import { createContext, useContext } from "react";
import { DEFAULT_REFRESH_RATE } from "../constants/fallbacks";
import { EStrategy, } from "./types";
export const defaultWalletOptions = {
    debug: false,
    refreshRates: {
        balance: DEFAULT_REFRESH_RATE,
        details: DEFAULT_REFRESH_RATE,
    },
    metadataResolver: null,
    ignoreNFTs: true,
    useHandles: false,
    strategy: EStrategy.CIP30,
};
export const defaultCachableWalletState = {
    activeWallet: null,
    details: null,
};
export const defaultWalletState = {
    balance: null,
    error: null,
    dAppConnector: null,
    options: defaultWalletOptions,
    initialized: {
        balance: false,
        details: false,
    },
    ...defaultCachableWalletState,
};
export const WalletContext = createContext({
    state: defaultWalletState,
    dispatch: () => { },
});
// Utility hook.
export const useWalletContext = () => useContext(WalletContext);
//# sourceMappingURL=context.js.map